import React, { useEffect, useState } from 'react'

import {
    FileTwoTone
} from '@ant-design/icons';

import { Button, Descriptions, Empty, Modal, Spin, Table, Tooltip } from 'antd';
import { useApi } from '../../Utils';
import Column from 'antd/lib/table/Column';

import {
    ReloadOutlined,
    CheckCircleTwoTone,
    FireTwoTone,
    AppstoreTwoTone,
} from '@ant-design/icons'

import { useSelector } from 'react-redux';
import calculateMenu from './calculateMenu';

import {
    Menu,
    Item,
    Separator,
    useContextMenu
} from "react-contexify";

import "react-contexify/dist/ReactContexify.css";

const MENU_ID = "menu-id";

export default function WarehouseSyncAR({ isMobile, exposeSubMenu, setMainLoading }: any) {
    // const [loading, setLoading] = useState(true)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 30,
        total: 0
    });

    const { fetch, data, loading, refetchLast } = useApi<any>('get', `v3/ar/list`, { // errors setLoading
        onRequest: false,
        requiredToken: true
    })

    const e_RetryingDocs = useApi<any>('get', 'v3/ar/retry', {
        onRequest: true,
        requiredToken: true
    })

    const [records, setRecords] = React.useState<any[]>([])
    const [filters, setFilters] = React.useState<any>({})
    const [selectedRecord, setRecord] = React.useState()

    const [modal1Open, setModal1Open] = useState(false)
    // const [preview, setPreview] = useState()
    const [modalReprocess, setModalReprocess] = useState(false)

    const e_PreviewDocument = useApi<any>('get', `v3/ar/dfPreview`, { // errors setLoading
        onRequest: false,
        requiredToken: true
    })
    
    const { permissions: _permissions, userInfo: { id_client } } = useSelector((state: any) => state)
    const permissions = _permissions as string[]

    useEffect(() => {
        // if (!loading){
            // setLoading(e_RetryingDocs.loading)
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [e_RetryingDocs.loading])

    useEffect(() => {
        setMainLoading(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!!exposeSubMenu) {
            exposeSubMenu(calculateMenu(permissions, id_client))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissions, exposeSubMenu])

    useEffect(() => {
        if (data) {
            setPagination({
                current: data.documents.current_page,
                pageSize: data.documents.per_page,
                total: data.documents.total
            })
            setRecords(data.documents.data)
            setFilters(data.filters)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if (selectedRecord?.id > 0) {
            (async () => {
                await e_PreviewDocument.fetch({
                    bolId: selectedRecord.id
                })
            })()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRecord])

    // useEffect(() => {
    //     // console.log(e_PreviewDocument.data)
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [e_PreviewDocument.data])

    const { show } = useContextMenu({
        id: MENU_ID
    });

    function displayMenu(e, record) {
        setRecord(record)
        show(e);
        console.log(record)
        return false;
    }

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            console.log("📋 Texto copiado:", text);
        } catch (err) {
            console.error("❌ Error al copiar:", err);
        }
    };

    const showPreview = async (record) => {
        setModal1Open(true)
        console.log(record)
    }

    const e_Reprocess = useApi("get", "v3/ar/syncIndividual", {
        onRequest: true,
        requiredToken: true
    })

    const e_MarkResolved = useApi("post", "v3/ar/markAsResolved", {
        onRequest: true,
        requiredToken: true
    })

    const confirmReprocess = () => {
        setModalReprocess(true)
    };

    useEffect(() => {
        if (e_Reprocess?.data){
            console.log(e_Reprocess.data)
            console.log('e_Reprocess.data', e_Reprocess.data)
        }
    }, [e_Reprocess.data])

    useEffect(() => {
        if (e_MarkResolved?.data?.success) {
            (async () => {
                await refetchLast();
            })()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [e_MarkResolved.data])

    const handleOk = async () => {
        // setModalText('The modal will be closed after two seconds');
        // setConfirmLoading(true);
        // setTimeout(() => {
        //     setOpen(false);
        //     setConfirmLoading(false);
        // }, 2000);
        console.log(selectedRecord)
        if (selectedRecord?.id > 0) {
            await e_Reprocess.fetch({
                bolId: selectedRecord?.id
            })
            // await refetchLast()
            // setModalReprocess(false);
        }
    };

    const handleCancel = () => {
        setModalReprocess(false);
    };

    return (
        <div className="App">
            <div className="Orders">
                <Modal
                    title="Reintentar sincronización"
                    open={modalReprocess}
                    onOk={handleOk}
                    confirmLoading={e_Reprocess.loading}
                    onCancel={handleCancel}
                    cancelButtonProps={{
                        disabled: e_Reprocess.loading
                    }}
                    maskClosable={!e_Reprocess.loading}
                    closable={!e_Reprocess.loading}
                >
                    <p>¿Quieres reintentar la sincronización?</p>
                </Modal>
                <Modal
                    title={`Vista previa del documento en: "${selectedRecord?.BaseDeDatos}"`}
                    style={{ top: 20 }}
                    visible={modal1Open}
                    width={"80%"}
                    onOk={() => setModal1Open(false)}
                    onCancel={() => setModal1Open(false)}
                    key={`ModalPreview`}
                >
                    {e_PreviewDocument.loading || !e_PreviewDocument?.data
                        ? <Spin  size="large"/>
                        : <>
                            <Descriptions column={2} title={`${selectedRecord?.Tipo} ${selectedRecord?.Letra} ${selectedRecord?.PtoVenta} ${selectedRecord?.Numero}`} bordered>
                                <Descriptions.Item label={<strong>Cliente</strong>}>{e_PreviewDocument.data.document.cliente} {e_PreviewDocument.data.document.ClienteDescripcion}</Descriptions.Item>
                                <Descriptions.Item label={<strong>Numero</strong>}>{selectedRecord?.Letra} {selectedRecord?.PtoVenta} {selectedRecord?.Numero}</Descriptions.Item>
                                <Descriptions.Item label={<strong>Vendedor</strong>}>{e_PreviewDocument.data.document.Vendedor}</Descriptions.Item>
                                <Descriptions.Item label={<strong>Fecha</strong>}>{e_PreviewDocument.data.bolDocument.Fecha} {e_PreviewDocument.data.bolDocument.Hora}</Descriptions.Item>
                                <Descriptions.Item label={<strong>Lista de precio</strong>}>{e_PreviewDocument.data.document.ListaDePrecios}</Descriptions.Item>
                                <Descriptions.Item label={<strong>C.A.E.</strong>}>{e_PreviewDocument.data.document.CAE}</Descriptions.Item>
                                <Descriptions.Item label={<strong>Email</strong>}>{e_PreviewDocument.data.document.Email}</Descriptions.Item>
                                <Descriptions.Item label={<strong>Tipo de entrega</strong>}>Inmediata</Descriptions.Item>
                            </Descriptions>
                            
                            <br />
                            
                            <Table
                                dataSource={e_PreviewDocument.data.document.FacturaDetalle}
                                loading={e_PreviewDocument.loading}
                                pagination={false}
                                className='TableFacturaDetalle'
                                size='small'
                                locale={{
                                    emptyText: (
                                        <Empty
                                            style={{ marginTop: '32px', marginBottom: '48px' }}
                                            description={'El documento no tiene detalle.'}
                                        >
                                        </Empty>
                                    )
                                }}
                                rowKey={(record, index) => `${record.NroItem}-${index}`}
                            >
                                <Column
                                    dataIndex='Articulo'
                                    key='Articulo'
                                    title="Artículo"
                                />

                                <Column
                                    dataIndex='ArticuloDetalle'
                                    key='ArticuloDetalle'
                                    title=""
                                />

                                <Column
                                    dataIndex='Cantidad'
                                    key='Cantidad'
                                    title="Cantidad"
                                />

                                <Column
                                    dataIndex='Precio'
                                    key='Precio'
                                    title="Precio"
                                />

                                <Column
                                    dataIndex='Descuento'
                                    key='Descuento'
                                    title="% Desc."
                                />

                                <Column
                                    dataIndex='MontoDescuento'
                                    key='MontoDescuento'
                                    title="Monto desc."
                                />

                                <Column
                                    dataIndex='Monto'
                                    key='Monto'
                                    title="Monto"
                                />
                            </Table>

                            <br />

                            <div>
                                <Table
                                    dataSource={e_PreviewDocument.data.document.ValoresDetalle}
                                    loading={e_PreviewDocument.loading}
                                    pagination={false}
                                    className='TableValoresDetalle'
                                    size='small'
                                    locale={{
                                        emptyText: (
                                            <Empty
                                                style={{ marginTop: '32px', marginBottom: '48px' }}
                                                description={'El documento no tiene detalle.'}
                                            >
                                            </Empty>
                                        )
                                    }}
                                    rowKey={(record, index) => `VD${record.NroItem}-${index}`}
                                >
                                    <Column
                                        dataIndex='Valor'
                                        key='Valor'
                                        title="Valor"
                                    />

                                    <Column
                                        dataIndex='ValorDetalle'
                                        key='ValorDetalle'
                                        title=""
                                    />

                                    <Column
                                        dataIndex='Monto'
                                        key='Monto'
                                        title="Monto"
                                    />

                                    <Column
                                        dataIndex='Recibido'
                                        key='Recibido'
                                        title="Recibido"
                                    />

                                </Table>


                            </div>
                        </>}
                </Modal>
                <Menu id={MENU_ID}>
                    <Item onClick={() => {
                        copyToClipboard(`${selectedRecord?.Numero}`)
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <FileTwoTone twoToneColor={'#000'} />
                            <div>
                                <div><strong>{selectedRecord?.BaseDeDatos}</strong> </div>
                                <>{selectedRecord?.Tipo} {selectedRecord?.Letra} {selectedRecord?.PtoVenta} {selectedRecord?.Numero}</>
                                {/* <small>Copia el número</small> */}
                            </div>
                        </div>
                    </Item>
                    {/* Lógica de error. */}
                    {<>
                        <Separator />
                        <Item disabled={selectedRecord?.sync !== "-2"} onClick={async () => {
                            await e_MarkResolved.fetch({
                                bolId: selectedRecord?.id
                            })
                        }}>
                            <CheckCircleTwoTone twoToneColor="#52c41a" /> Marcar como Sincronizado
                        </Item>
                        <Item disabled={selectedRecord?.sync !== "-2"} onClick={() => {
                            confirmReprocess()
                        }}>
                            <FireTwoTone twoToneColor="#eb2f96" /> Reintentar sincronización
                        </Item>
                    </>}
                    <Separator />
                    
                    <Item onClick={async () => {
                        await showPreview(selectedRecord)
                    }}>
                        <AppstoreTwoTone /> Vista Previa del Documento
                    </Item>
                    {/* <Submenu label="Submenu">
                        <Item onClick={handleItemClick}>
                            Sub Item 1
                        </Item>
                        <Item onClick={handleItemClick}>Sub Item 2</Item>
                    </Submenu> */}
                </Menu>
                <div className="Toolbar" style={{
                    flex: 1,
                    paddingLeft: 16,
                    paddingRight: 16,
                    paddingTop: 24,
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Button disabled={(data?.documents?.data?.filter(a => a.sync === "-2")?.length) === 0} type="danger" loading={loading} onClick={async () => {
                        if (data?.original?.filters) {
                            await e_RetryingDocs.fetch({
                                "hash": Buffer.from(JSON.stringify(data.original.filters)).toString('base64')
                            })
                        }
                    }} icon={<ReloadOutlined />}>Ejecutar reintento</Button>
                    {/* <Button
                        onClick={() => {
                            setFilters({});
                            setSorter({});
                            setPagination({ current: 1 });
                            fetchData({ page: 1 });
                        }}
                    >
                        Reiniciar filtros
                    </Button> */}
                    <Button loading={loading} onClick={async () => {
                        await refetchLast()
                    }} icon={<ReloadOutlined />}>Actualizar listado</Button>
                </div>
                <div className="Wrapper">
                    <Table
                        dataSource={records}
                        loading={loading || e_MarkResolved.loading || e_RetryingDocs.loading}
                        pagination={pagination}
                        onChange={(newPagination, localFilters, localSorter) => {
                            fetch({
                                page: newPagination.current,
                                pageSize: newPagination.pageSize,
                                filters: JSON.stringify(localFilters),
                                sorter: JSON.stringify(localSorter)
                            })
                        }}
                        onRow={(record => ({
                            onContextMenu: (event) => displayMenu(event, record)
                            // onContextMenu: (event) => show(record)
                        }))}
                        expandable={{
                            expandedRowRender: (record) => (
                                <Table
                                    columns={[
                                        { title: "Fecha y hora", dataIndex: "created_at", key : "created_at", width: 150 },
                                        { title: "Mensaje", dataIndex: "errMessage", key: 'errMessage' }
                                    ]}
                                    dataSource={record.integration_logs}
                                    pagination={false}
                                />
                            ),
                            rowExpandable: (record) => record.integration_logs?.length
                            // showExpandColumn: record.integration_logs?.length
                        }}
                        className='TableListAll'
                        size='small'
                        locale={{
                            emptyText: (
                                <Empty
                                    style={{ marginTop: '32px', marginBottom: '48px' }}
                                    description={'No se han encontrado documentos con los criterios de búsqueda.'}
                                >
                                </Empty>
                            )
                        }}
                        rowKey={(record, index) => `${record.id}-${index}`}
                        footer={() => !loading ? <>Mostrando {records?.length} documentos de un total de {data?.documents?.total}.</> : null}
                    >
                        {/* Ícono con el estado de la sincronización */}
                        <Column
                            dataIndex='erpIcon'
                            key='erpIcon'
                            render={(_value, _record) => {
                                const _sync = Number(_record.sync)
                                const syncNumber = _sync >= 1 ? 1 : _sync === 0 ? 0 : -1;

                                const state = new Map([
                                    [1, {
                                        color: '#52c41a',
                                        message: 'Comprobante sincronizado.'
                                    }],
                                    [0, {
                                        color: undefined,
                                        message: 'Pendiente de sincronización.'
                                    }],
                                    [-1, {
                                        color: '#eb2f96',
                                        message: 'Error al sincronizar.'
                                    }]
                                ])

                                return <Tooltip placement="right" title={state.get(syncNumber)?.message}>
                                    <FileTwoTone twoToneColor={state.get(syncNumber)?.color} />
                                </Tooltip>
                            }}
                            filters={[
                                { text: "OK", value: "OK"},
                                { text: "ERR", value: "ERR"},
                                { text: "PEN", value: "PEN"}
                            ]}
                        />

                        <Column
                            dataIndex='BaseDeDatos'
                            key='BaseDeDatos'
                            title="Base de Datos"
                            filters={filters?.BaseDeDatos || []}
                        />

                        <Column
                            dataIndex='Tipo'
                            key='Tipo'
                            title="Tipo Doc."
                            filters={filters?.TipoDoc || []}
                        />

                        <Column
                            dataIndex='Letra'
                            key='Letra'
                            title="Letra"
                            filters={filters?.Letra || []}
                        />

                        <Column
                            dataIndex='Numero'
                            key='Numero'
                            title="Numero"
                            sorter
                        />

                        <Column
                            dataIndex='Fecha'
                            key='Fecha'
                            title="Fecha Emisión"
                            render={(_value, record) => `${record.Fecha} ${record.Hora}`}
                            sorter
                        />

                        <Column
                            dataIndex='Fecha'
                            key='Fecha'
                            title="Última Sincro"
                            render={(_value, record) => `${record.created_at}`}
                            sorter
                        />
                    </Table>
                </div>
            </div>
        </div>
    )
}
